import Credentials from '@/modules/auth/domain/credentials'
import moment from 'moment'
import { PermissionType } from '@/modules/user/type/permissionType'
import { Route } from 'vue-router'
import User from '@/modules/user/domain/user'
import Vue from 'vue'

const LOGIN_URL = '/api/auth/token'
const REDIRECT_TO_PARAM = 'redirectTo'

export default {
  async login (credentials: Credentials) {
    const response = await (<any>Vue).http.post(LOGIN_URL, credentials, {})

    return {
      accessToken: response.data.token,
      validTo: moment().add(response.data.expiresIn, 's')
    }
  },
  loginPath (route: Route) {
    let path = '/login'
    if (route.query[REDIRECT_TO_PARAM]) {
      path += `?${REDIRECT_TO_PARAM}=${route.query[REDIRECT_TO_PARAM]}`
    } else if (['login', 'logout', 'root', 'home'].indexOf(route.name || '') < 0) {
      path += `?${REDIRECT_TO_PARAM}=${encodeURIComponent(route.fullPath)}`
    }
    return path
  },
  mainPath (currentRoute: Route, user?: User) {
    const redirectToVal = currentRoute.query[REDIRECT_TO_PARAM]
    if (redirectToVal) {
      return decodeURIComponent(<string>redirectToVal)
    } else if (user && user.permissions.indexOf(PermissionType.WORK_RECORD_PERSONAL.toString()) >= 0) {
      return { name: 'workRecordsPersonal' }
    } else if (user && user.permissions.indexOf(PermissionType.COMPANY_PARTNER.toString()) >= 0) {
      return { name: 'partners' }
    } else {
      return { name: 'home' }
    }
  }
}
